import firebase from "firebase";
import { firebaseConfig } from "../../constant";

const app = firebase.initializeApp(firebaseConfig);

export { app };
